var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBackgroundImage = function SvgBackgroundImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 900V0H815.5L624 900h816Z",
    fill: "#005F9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v900h624.5L816 0H0Z",
    fill: "#0074BD"
  })));
};

export { SvgBackgroundImage as ReactComponent };
export default __webpack_public_path__ + "8a6009c76a8fbb886e6082e913a1f42e.svg";